import { render } from "./generalAlert.vue?vue&type=template&id=511134dd"
import script from "./generalAlert.vue?vue&type=script&lang=js"
export * from "./generalAlert.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__